module.exports = __webpack_public_path__ + "static/undraw_Mailbox_re_dvds-b3cb862bfaa1e57956181ebfc9fe5b80.svg";